module.exports = __webpack_public_path__ + "img/gift.ca06377d.svg";